import apiClient from './api_client_requests';

export default (config) => {
    return async (payload) => {
        //? for debug: console.log(payload);
        let result = await apiClient(config).apiMethod({
            method: 'Winners',
            args: {},
        });

        return result;
    };
};
